// ENUM CLEAN UP
// eslint-disable-next-line no-restricted-syntax
export enum LoadingTitleSize {
    LARGE = 450,
    MEDIUM = 300,
    SAVED_VIEWS = 215,
    SMALL = 150,
    XSMALL = 50,
}
